// Public runtime config — `GET /api/v1/config` (F-B / ADR-0022).
//
// Exposes the code-width bounds CodeEntry needs at runtime. Visitors
// fetch this once per session (TanStack Query `staleTime: Infinity`).
//
// Note: this endpoint sits at `/api/v1/config` (with the `/v1/`
// segment); the rest of the visitor surface is unversioned. Kept
// versioned so a future public-API split has a natural home; the
// client wrapper just calls the absolute path off `getApiClient`'s
// base which already includes `/api`.

import { getApiClient } from "./client";

export interface PublicConfig {
  codeDigits: number;
  codeMinDigits: number;
  codeMaxDigits: number;
}

export async function getPublicConfig(): Promise<PublicConfig> {
  const { data } = await getApiClient().get<PublicConfig>("/v1/config");
  return data;
}
